import {Action} from '@ngrx/store';
import * as _ from 'lodash';
import {SelectedItem} from '../../order/models/order';
import {SubscriptionsFilter, SubscriptionsList} from '../models/subscription';
import {
  LoadSubListSuccessAction, OrderSubListByAction,
  PageSubListToAction,
  QuickSearchSubListAction,
  SearchSubListAction, SelectOneItemSubListAction,
  subListActionTypes,
  ToggleSearchSubListAction, ToggleSubListSelectionAction
} from '../actions/subscription-list';

export interface SubListState {
  array: SubscriptionsList[];
  showFilter: boolean;
  quickSearch: string;
  filter: SubscriptionsFilter;
  page: number;
  pageSize: number;
  orderBy: string;
  count: number;
  selectedSubscription: SelectedItem[];
  selectedOneSubscription: SelectedItem;
}

const initialState: SubListState = {
  array: undefined,
  showFilter: false,
  quickSearch: undefined,
  filter: undefined,
  page: 1,
  pageSize: 10,
  orderBy: 'created descending',
  count: 0,
  selectedSubscription: [],
  selectedOneSubscription: undefined,
};

export function SubListReducer(state: SubListState = initialState, action: Action): SubListState {
  switch (action.type) {
    case subListActionTypes.TOGGLE_SEARCH:
      return handleToggleSearchAction(state, action);
    case subListActionTypes.QUICK_SEARCH:
      return handleQuickSearchAction(state, action);
    case subListActionTypes.SEARCH:
      return handleSearchAction(state, action);
    case subListActionTypes.PAGE_TO:
      return handlePageToAction(state, action);
    case subListActionTypes.CHANGE_PAGE_SIZE:
      return handleChangePageSizeAction(state, action);
    case subListActionTypes.ORDER_BY:
      return handleOrderByAction(state, action);
    case subListActionTypes.TOGGLE_SELECTION:
      return handleToggleSubscriptionSelectionAction(state, action);
    case subListActionTypes.SELECT_PAGE:
      return handleSelectPageSubscriptionAction(state);
    case subListActionTypes.SELECT_PAGE_SITE_CONTEXT:
      return handleSelectPageSubscriptionSiteContextAction(state);
    case subListActionTypes.LOAD_SUCCESS:
      return handleLoadSuccessAction(state, action);
    case subListActionTypes.LOAD_FAIL:
      return handleLoadErrorActions(state);
    case subListActionTypes.SELECT_ONE_ITEM:
      return handleLoadSelectOneItemActions(state, action);
    case subListActionTypes.CLEAR:
      return handleLoadClearActions(state);
    case subListActionTypes.CLEAR_ALL:
      return handleLoadClearALLActions(state);
    case subListActionTypes.CLEAR_ONE_ITEM:
      return handleLoadClearOneItemActions(state);
    default:
      return state;
  }
}

function handleToggleSearchAction(state: SubListState, action: ToggleSearchSubListAction): SubListState {
  const newState: SubListState = {
    ... state,
    showFilter: action.payload,
    selectedSubscription: [],
    selectedOneSubscription: undefined
  };
  return newState;
}

function handleQuickSearchAction(state: SubListState, action: QuickSearchSubListAction): SubListState {
  const newState: SubListState = {
    ... state,
    quickSearch: action.payload,
    page: 1,
    selectedSubscription: [],
    selectedOneSubscription: undefined
  };
  return newState;
}

function handleSearchAction(state: SubListState, action: SearchSubListAction): SubListState {
  const newState: SubListState = {
    ... state,
    filter: action.payload,
    page: 1,
    selectedSubscription: [],
    selectedOneSubscription: undefined
  };
  return newState;
}

function handlePageToAction(state: SubListState, action: PageSubListToAction): SubListState {
  const newState: SubListState = {
    ... state,
    page: action.payload,
    selectedSubscription: [],
    selectedOneSubscription: undefined
  };
  return newState;
}

function handleLoadSuccessAction(state: SubListState, action: LoadSubListSuccessAction): SubListState {
  const newState: SubListState = {
    ... state,
    array: action.payload.array,
    count: action.payload.count,
    selectedSubscription: [],
    selectedOneSubscription: undefined
  };
  return newState;
}
function handleSelectPageSubscriptionAction(state: SubListState): SubListState {
  let selectedSubscription;
  selectedSubscription =  _.union(state.selectedSubscription,
      _.map(state.array, subscription => ({ uuid: subscription.subscriptionUuid , name: subscription.subscriptionName,
                                            clientName: subscription.clientName , productName: subscription.productName,
                                            clientUuid: subscription.clientUuid,
                                            contractUuid: subscription.contractUuid, deliveryDate: subscription.deliveryDate,
                                            start: subscription.startBilling , billedUp : subscription.billedUp ,
                                            orderUuid: subscription.orderUuid, productId: subscription.productID ,
                                            companyUuid: subscription.companyUuid, end: subscription.endBilling ,
                                            status: subscription.status
      })));
  const newState: SubListState = {
    ... state,
    selectedOneSubscription: undefined,
    selectedSubscription: selectedSubscription,
  };
  return newState;
}

function handleSelectPageSubscriptionSiteContextAction(state: SubListState): SubListState {
  let selectedSubscription;
  selectedSubscription =   _.map(state.array, subscription => (

         {
          uuid: subscription.subscriptionUuid , name: subscription.subscriptionName,
          clientName: subscription.clientName , productName: subscription.productName,
          contractUuid: subscription.contractUuid, deliveryDate: subscription.deliveryDate,
          clientUuid: subscription.clientUuid,
          start: subscription.startBilling , billedUp : subscription.billedUp ,
          orderUuid: subscription.orderUuid, productId: subscription.productID ,
          companyUuid: subscription.companyUuid, end: subscription.endBilling ,
          status: subscription.status
        }
      ));
  const newState: SubListState = {
    ... state,
    selectedOneSubscription: undefined,
    selectedSubscription: selectedSubscription,
  };
  return newState;
}

function handleToggleSubscriptionSelectionAction(state: SubListState, action: ToggleSubListSelectionAction): SubListState {
  const selectedIndex = _.findIndex(state.selectedSubscription, ['uuid', action.payload.subscriptionUuid]);
  let selected: SelectedItem[];
  let  newState: SubListState;
  if (selectedIndex > -1) {
    selected = _.filter(state.selectedSubscription, sc => sc.uuid !== action.payload.subscriptionUuid);
  } else {
    // tslint:disable-next-line:typedef
    const subscription = _.find(state.array, function (u) {
      return u.subscriptionUuid === action.payload.subscriptionUuid && u.endBilling === action.payload.endBilling
    });
    if (subscription.name && subscription.uuid) {
      const selectedSubscription: SelectedItem = {
        uuid: subscription.uuid,
        name: subscription.name ,
        deliveryDate: subscription.deliveryDate,
        clientUuid: subscription.clientUuid,
        clientName: subscription.clientName,
        productName: subscription.productName
      };
      selected = [...state.selectedSubscription, selectedSubscription];


      newState = {
        ...state,
        selectedOneSubscription: undefined,
        selectedSubscription: selected
      };
    } else {
      const selectedSubscription: SelectedItem = {
        uuid: subscription.subscriptionUuid, deliveryDate: subscription.deliveryDate,
        name: subscription.subscriptionName, billedUp: subscription.billedUp,
        start: subscription.startBilling, orderUuid: action.payload.orderUuid,
        contractUuid: action.payload.contractUuid, companyUuid: action.payload.companyUuid,
        productId: action.payload.productID, end: subscription.endBilling,
        status: subscription.status, clientUuid: subscription.clientUuid,
        clientName: subscription.clientName, productName: subscription.productName
      };
      selected = [...state.selectedSubscription, selectedSubscription];



  }
  }
  newState = {
    ...state,
    selectedOneSubscription: undefined,
    selectedSubscription: selected
  };
  return newState;
}


function handleChangePageSizeAction(state: SubListState, action: PageSubListToAction): SubListState {
  const newState: SubListState = {
    ... state,
    page: 1,
    pageSize: action.payload,
    selectedSubscription: [],
    selectedOneSubscription: undefined
  };
  return newState;
}
function handleOrderByAction(state: SubListState, action: OrderSubListByAction): SubListState {
  const newState: SubListState = {
    ... state,
    orderBy: action.payload,
    selectedSubscription: [],
    selectedOneSubscription: undefined
  };
  return newState;
}

function handleLoadClearActions(state: SubListState): SubListState {
  const newState: SubListState = {
    ... state,
    selectedSubscription: [],
    selectedOneSubscription: undefined,
  };
  return newState;
}
function handleLoadClearALLActions(state: SubListState): SubListState {
  const newState: SubListState = {
    ... state,
    array: undefined,
    selectedSubscription: [],
    selectedOneSubscription: undefined,
  };
  return newState;
}
function handleLoadSelectOneItemActions(state: SubListState , action: SelectOneItemSubListAction): SubListState {
  let item;
  if (action.payload.subscriptionUuid) {
     item = {
      uuid: action.payload.subscriptionUuid, name: action.payload.subscriptionName,
      clientName: action.payload.clientName, productName: action.payload.productName,
      productId: action.payload.productID, clientUuid: action.payload.clientUuid,
      start: action.payload.startBilling, contractUuid: action.payload.contractUuid,
      deliveryDate: action.payload.deliveryDate, billedUp: action.payload.billedUp,
      companyUuid: action.payload.companyUuid, orderUuid: action.payload.orderUuid,
      end: action.payload.endBilling,
      status: action.payload.status
    }
    } else {
       item = {uuid: action.payload.uuid, name: action.payload.name}
       if (action.payload.clientProjectID) {
          item.clientProjectID = action.payload.clientProjectID;
        }
    }
  const newState: SubListState = {
    ... state,
    selectedOneSubscription: item

  };
  return newState;
}
function handleLoadClearOneItemActions(state: SubListState): SubListState {
  const newState: SubListState = {
    ... state,
    selectedOneSubscription: undefined,
  };
  return newState;
}

function handleLoadErrorActions(state: SubListState): SubListState {
  return state;
}

export const subListSelectors = {
  showFilter: (state: SubListState) => _.get(state, 'showFilter', false),
  quickSearch: (state: SubListState) => _.get(state, 'quickSearch'),
  filter: (state: SubListState) => _.get(state, 'filter'),
  page: (state: SubListState) => _.get(state, 'page', 1),
  pageSize: (state: SubListState) => _.get(state, 'pageSize', 10),
  orderBy: (state: SubListState) => _.get(state, 'orderBy'),
  array: (state: SubListState) => _.get(state, 'array', []),
  count: (state: SubListState) => _.get(state, 'count', 0),
  selectedSubscription: (state: SubListState) => _.get(state, 'selectedSubscription', []),
  selectedOneSubscription: (state: SubListState) => _.get(state, 'selectedOneSubscription')
};
